import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityComponent } from '@component/entity-component';
import { CategoryType } from '@enum/category-type';
import { Advert } from '@model/entities/advert';
import { PaginationSet } from '@model/paginationset/paginationset';
import { AdvertService } from '@service/advert/advert.service';
import { DialogService } from '@service/dialog.service';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { LoadingService } from '@service/loading.service';
import { MobileService } from '@service/mobile.service';
import { PreflightSearchService } from '@service/preflight-search/preflight-search.service';
import { RestService } from '@service/rest/rest.service';
import { ScrollService } from '@service/scroll.service';
import { SentryService } from '@service/sentry.service';
import { SliderImagesService } from '@service/slider-images.service';
import { StateService } from '@service/state.service';
import { ToastService } from '@service/toast/toast.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';

@Component({
  selector: 'app-advert',
  templateUrl: './advert.component.html',
  styleUrls: ['./advert.component.scss'],
})
export class AdvertComponent extends EntityComponent implements OnInit {
  public pagination: PaginationSet<Advert>;

  public preflightValues: string[];

  // offer it to template
  public CategoryType = CategoryType;

  public entityTypeIdentifier: EntityTypeIdentifier = 'advert';

  public hasSliderImages: boolean = false;

  constructor(
    private advertService: AdvertService,
    private toastService: ToastService,
    private preflightService: PreflightSearchService,
    public ScrollService: ScrollService,
    public EntityTypeConfigService: EntityTypeConfigService,
    private dialogService: DialogService,
    public MobileService: MobileService,
    public StateService: StateService,
    public LoadingService: LoadingService,
    protected RestService: RestService,
    protected SentryService: SentryService,
    public Router: Router,
    public ActivatedRoute: ActivatedRoute,
    public sliderImagesService: SliderImagesService,
  ) {
    super(EntityTypeConfigService, ScrollService, RestService, SentryService, StateService, Router, ActivatedRoute);
  }

  public ngOnInit() {
    super.ngOnInit();

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('advert');
  }

  public onPreflightSearch(query: string): void {
    if (query.length < 3) return;

    this.preflightService.doPreflightSearch({ tags: 'ADVERT', search_string: query }).then((preflightValues) => {
      this.preflightValues = preflightValues;
    });
  }

  public getEntities(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.LoadingService.startLoad();

      this.advertService
        .searchAdverts(this.StateService.queryParams)
        .then((adverts) => {
          this.pagination = adverts;

          if (
            typeof this.StateService.queryParams.zip_city != 'undefined' &&
            typeof this.StateService.queryParams.radius_search_km == 'undefined' &&
            adverts.count == 0
          )
            this.dialogService.informDialog(
              'In diesem Ort gibt es keine Treffer. Erweitere den Umkreis deines Standorts um mehr Ergebnisse zu bekommen.',
            );
        })
        .catch((err) => {
          if (err && err.error && err.error.message == 'no result') {
            this.toastService.showWarning('Es konnten keine Ergebnisse zu Ihrer Suche gefunden werden.');
          } else {
            this.toastService.showError('Anzeigen konnten nicht abgerufen werden.');
          }
        })
        .finally(() => {
          this.LoadingService.stopLoad();
          resolve();
        });
    });
  }
}
